import Image from "next/image";

export function Logo({ className = "w-20", imageClassName = "w-32 h-auto lg:w-64" }: { className?: string; imageClassName?: string }) {
  return (
    <div className={`flex flex-none h-fit overflow-y-hidden items-baseline gap-0 ${className}`}>
      <Image src={"/images/tmrwpr-logo.png"} alt="Logo" width={200} height={100} className={`object-cover ${imageClassName}`} />
    </div>
  );
}